import React from 'react';

const TimeBufferRequestMenuItem = () => {
  return <></>;
};

export default React.memo(TimeBufferRequestMenuItem);
